import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

import Airtime from '../../src/assets/GiftAsset/airtime.png';
import Clothes from '../../src/assets/GiftAsset/clothes.png';
import Credit from '../../src/assets/GiftAsset/credit.png';
import { useMediaQuery, useTheme, CircularProgress, CardContent, IconButton, InputAdornment, Typography, Box, Button, TextField, Checkbox, Container, Card } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Header from "../components/Header/loginheader";
import backgroundImage from "../assets/GiftAsset/man.svg";

const Login = () => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Extract search parameters from URL
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const urlTpage = searchParams.get("tpage") || "home";
  const urlEid = searchParams.get("eid") || "";
  
  // Set email state with eid value
  const [email, setEmail] = useState(urlEid);

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  useEffect(() => {
    const eidFromUrl = searchParams.get("eid");
    const tpageFromUrl = searchParams.get("tpage");
  
    if (eidFromUrl) {
      setEmail(eidFromUrl);  
    }
  
    if (tpageFromUrl) {
      localStorage.setItem("tpage", tpageFromUrl);
    }
  }, [searchParams]);
  
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.post(
        "https://daradservice.azurewebsites.net/api/DaradsCustomers/Customer-Log",
        { email, password },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "text/plain",
          },
        }
      );

      const token = response.data?.data?.authToken;
      const customerId = response.data?.data?.customerId;
      const userEmail = response.data?.data?.email || email;

      if (token && customerId && userEmail) {
        localStorage.setItem("token", token);
        sessionStorage.setItem("userEmail", userEmail);
        sessionStorage.setItem("userId", customerId);
      
        const balance = response.data?.data?.walletData?.balance;
        if (balance !== undefined && balance !== null) {
          sessionStorage.setItem("userBalance", balance);
        }
      
        // Redirect logic
        const storedTpage = localStorage.getItem("tpage") || urlTpage;
        let redirectPath = "/product/giftshop";
      
        if (storedTpage === "gshop") {
          redirectPath = "/product/giftshop";
        } else if (storedTpage === "p2p") {
          redirectPath = "/product/ptwop";
        } else if (storedTpage === "p2pMarket") {
          redirectPath = "/product/marketplace";
        } else if (storedTpage === "dcourse") {
          redirectPath = "/product/digital-courses";
        }
      
        navigate(redirectPath);
      }
       else {
        setError("Invalid login credentials. Please try again.");
      }
    } catch (err) {
      console.error("Login Error:", err.response || err.message);
      setError(err.response?.data?.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            backgroundColor: "#f9f9f9",
            flexDirection: isDesktop ? "row" : "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: isDesktop ? "70%" : "100%",
              height: "100%",
              boxShadow: 3,
              borderRadius: 3,
              overflow: "hidden",
              backgroundColor: "#fff",
              flexDirection: isDesktop ? "row" : "column",
            }}
          >
            {/* Left Side */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                backgroundColor: "#f5f5f5",
                padding: isDesktop ? "60px" : "20px",
                minHeight: 450,
              }}
            >
              {/* Background Image */}
              <Box
                sx={{
                  width: "100%",
                  height: "50vh", 
                  backgroundImage: `url(${backgroundImage})`,
                  backgroundSize: isDesktop ? "60%" : "cover",
                  backgroundPosition: isDesktop ? "left" : "center center", 
                  marginLeft: isDesktop ? "20%" : "0", 
                  backgroundRepeat: "no-repeat",
                  borderBottomRightRadius: "50% 50%",
                  overflow: "hidden",
                  transform: "scale(1.1)",
                }}
              />
              {/* Floating Card */}
              <Card
                sx={{
                  maxWidth: 400,
                  width: isDesktop ? "50%" : "100%",
                  borderRadius: 3,
                  boxShadow: 3,
                  border: "2px solid #D1B3FF",
                  position: isDesktop ? "absolute" : "relative",
                  top: isDesktop ? "40%" : "auto",
                  right: isDesktop ? "10px" : "auto",
                  transform: isDesktop ? "translateY(-50%)" : "none",
                  zIndex: 2,
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  marginTop: isDesktop ? 0 : 3,
                  padding: 2,
                }}
              >
                <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {/* First Button */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <IconButton sx={{ border: "2px solid #D1B3FF", borderRadius: 2, p: 1 }}>
                      <img src={Airtime} alt="Airtime" />
                    </IconButton>
                    <Button
                      fullWidth
                      sx={{
                        backgroundColor: "#fff",
                        color: "#5F04F6",
                        textTransform: "none",
                        border: "1px solid #D1B3FF",
                        borderRadius: 2,
                        fontFamily: "Urbanist, sans-serif",
                        fontWeight: 800,
                        fontSize: "16px",
                        display: "flex",
                        justifyContent: "flex-start",
                        padding: "8px 16px",
                        "&:hover": {
                          backgroundColor: "#5F04F6",
                          color: "#fff",
                        },
                      }}
                    >
                      Send Gift items
                    </Button>
                  </Box>
                  {/* Second Button */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <IconButton sx={{ border: "2px solid #D1B3FF", borderRadius: 2, p: 1 }}>
                      <img src={Credit} alt="Credit" />
                    </IconButton>
                    <Button
                      fullWidth
                      sx={{
                        backgroundColor: "#fff",
                        color: "#5F04F6",
                        textTransform: "none",
                        border: "1px solid #D1B3FF",
                        borderRadius: 2,
                        display: "flex",
                        fontFamily: "Urbanist, sans-serif",
                        fontWeight: 800,
                        fontSize: "16px",
                        justifyContent: "flex-start",
                        padding: "8px 16px",
                        "&:hover": {
                          backgroundColor: "#5F04F6",
                          color: "#fff",
                        },
                      }}
                    >
                      Digital Courses
                    </Button>
                  </Box>
                  {/* Third Button */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "flex-start" }}>
                    <IconButton sx={{ border: "2px solid #D1B3FF", borderRadius: 2, p: 1 }}>
                      <img src={Clothes} alt="Clothes" />
                    </IconButton>
                    <Button
                      fullWidth
                      sx={{
                        backgroundColor: "#fff",
                        color: "#5F04F6",
                        textTransform: "none",
                        border: "1px solid #D1B3FF",
                        borderRadius: 2,
                        display: "flex",
                        fontFamily: "Urbanist, sans-serif",
                        fontWeight: 800,
                        fontSize: "16px",
                        justifyContent: "flex-start",
                        padding: "8px 16px",
                        "&:hover": {
                          backgroundColor: "#5F04F6",
                          color: "#fff",
                        },
                      }}
                    >
                      Post P2P Product
                    </Button>
                  </Box>
                </CardContent>
              </Card>
              {/* Text Below the Image */}
              <Typography 
                variant="h6"
                sx={{
                  ...theme.typography.urbanist700,
                  fontSize: "48px",
                  lineHeight: "58px",
                  color: "#192252",
                  marginTop: "20px",
                  display: { xs: "none", md: "block" }
                }}
              >
                Virtual Top Up
              </Typography>
              <Typography 
                variant="body2"
                textAlign="center"
                sx={{
                  maxWidth: 460,
                  mt: "10px",
                  color: "#848FAC",
                  ...theme.typography.Inter500,
                  fontSize: "20px",
                  display: { xs: "none", md: "block" }
                }}
              >
                With just a few clicks, you are some steps away from topping up your airtime and data bundle.
              </Typography>
            </Box>
            
            {/* Right Side (Login Form) */}
            <Container
              maxWidth="sm"
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: { xs: 2, sm: 4 },
              }}
            >
              <Card sx={{ padding: 4, width: "100%" }}>
                <Box sx={{ textAlign: "left" }}>
                  <Box
                    sx={{
                      textAlign: "center",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#000000",
                        textTransform: "none",
                        ...theme.typography.urbanist700,
                        fontSize: { xs: "24px", sm: "24px", md: "48px" },
                        lineHeight: { xs: "32px", sm: "36px", md: "46px" },
                        textAlign: { xs: "center", sm: "center", md: "left" },
                        maxWidth: "90%",
                      }}
                    >
                      Welcome Back to <br /> Mydarads
                    </Typography>
                  </Box>
                  <form onSubmit={handleLogin}>
                    <Box>
                      <Box sx={{ mt: "20px" }}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontFamily: "Inter, sans-serif",
                            fontWeight: 500,
                            fontSize: "14px",
                            lineHeight: "20px",
                          }}
                        >
                          Email
                        </Typography>
                        <TextField
                          fullWidth
                          margin="normal"
                          placeholder="Enter your email"
                          variant="outlined"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          InputProps={{
                            style: {
                              fontFamily: 'Inter, sans-serif',
                              fontWeight: 400,
                              color: '#101928',
                            },
                          }}
                        />
                      </Box>
                      <Box sx={{ mt: "20px" }}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontFamily: "Inter, sans-serif",
                            fontWeight: 500,
                            fontSize: "14px",
                            lineHeight: "20px",
                          }}
                        >
                          Password
                        </Typography>
                        <TextField
                          fullWidth
                          margin="normal"
                          placeholder="Enter password"
                          type={showPassword ? "text" : "password"}
                          variant="outlined"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() => setShowPassword(!showPassword)}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Box>
                      <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Box display="flex" alignItems="center">
                          <Checkbox />
                          <Typography
                            sx={{
                              fontFamily: "Urbanist",
                              fontWeight: 400,
                              fontSize: "14px",
                              lineHeight: "20px",
                            }}
                          >
                            Remember Me
                          </Typography>
                        </Box>
                      </Box>
                      {error && <Typography color="error">{error}</Typography>}
                      <Button
                        fullWidth
                        variant="contained"
                        type="submit"
                        sx={{
                          mt: 2,
                          borderRadius: "9999px",
                          backgroundColor: "#5F04F6",
                          color: "#fff",
                          "&:hover": { backgroundColor: "#4C03C9" },
                          padding: { xs: "8px 16px", sm: "10px 20px" },
                        }}
                        disabled={loading}
                      >
                        {loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Login"}
                      </Button>
                    </Box>
                  </form>
                  <Typography
                    variant="body2"
                    sx={{
                      mt: 5,
                      textAlign: "center",
                      color: "#848FAC",
                      ...theme.typography.Inter500,
                    }}
                  >
                    ©2025 Darads all rights reserved
                  </Typography>
                </Box>
              </Card>
            </Container>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Login;
